const slugUrl = ':slug([a-z-0-9_]+)-:id([0-9]+)/';
const seoSlugUrl = ':brand([a-z-0-9]+)_:slug([a-z-0-9]+)/';
const productId = ':id([0-9]+)/';
const token = ':token([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})/';
const topicId = ':topicId([0-9]+)/';
const staticPageSlug = ':slug/';
const flashSaleId = ':flashSaleId/';
const mstiSlugUrl = ':slug([A-Z]+)/';
const voucherUrl = ':voucherCode';

export const globalStoreUrl = 'https://maccaron.com';
export const devGlobalStoreUrl = 'https://dev.maccaron.com';
export const baseUrl = '/en/';
export const staticPageUrl = `${baseUrl}page/${staticPageSlug}`;
export const flashSaleUrl = `${baseUrl}campaign/${flashSaleId}`;
export const faqUrl = `${baseUrl}faq/`;
export const faqTopicUrl = `${baseUrl}faq/${topicId}`;
export const faqSearchUrl = `${baseUrl}faq/search/`;
export const marketingUrl = `${baseUrl}marketing/`;
export const offersUrl = `${marketingUrl}offers/`;
export const searchResultUrl = `${baseUrl}search-result/`;
export const cartUrl = `${baseUrl}mp/cart/`;

export const checkoutUrl = `${baseUrl}mp/checkout/`;
export const orderUrl = `${baseUrl}order/`;
export const orderDetailUrl = `${orderUrl}${token}`;
export const orderCheckoutSuccessUrl = `${orderDetailUrl}checkout-success/`;
export const productsUrl = `${baseUrl}products/`;
export const productDetailUrl = `${productsUrl}${slugUrl}`;
export const productDetailUrl2 = `${productsUrl}${seoSlugUrl}${productId}`;
export const categoryUrl = `${productsUrl}category/${slugUrl}`;
export const collectionUrl = `${productsUrl}collection/${slugUrl}`;
export const exhibitionsUrl = `${productsUrl}exhibitions/${slugUrl}`;
export const displayUrl = `${productsUrl}display/${slugUrl}`;
export const productListByTagUrl = `${productsUrl}tag/${slugUrl}`;
export const productListByVoucher = `${productsUrl}voucher/${voucherUrl}`;
export const accountUrl = `${baseUrl}account/`;
export const orderListUrl = `${accountUrl}orders/`;
export const activeOrderListUrl = `${accountUrl}active-orders/`;
export const pointListUrl = `${accountUrl}mypoints/`;
export const voucherListUrl = `${accountUrl}vouchers/`;
export const reviewListUrl = `${accountUrl}reviews/`;
export const shareUrl = `${accountUrl}share/`;
export const mobileUrl = `${baseUrl}page/maccaron-app-promotions/`;
export const changePasswordUrl = `${accountUrl}change-password/`;
export const contactUrl = `${accountUrl}contacts/`;
export const accountLoginUrl = `${accountUrl}login/`;
export const accountSignupUrl = `${accountUrl}signup/`;
export const accountDeleteUrl = `${accountUrl}delete-view/`;
export const accountDeleteConfirmUrl = `${accountUrl}${token}delete-confirm/`;
export const passwordResetUrl = `${accountUrl}password/reset/`;
export const passwordResetProcessUrl = `${accountUrl}password/reset/:uidb64/:token/`;
export const emailVerifyRequestUrl = `${accountUrl}verify-email/`;
export const emailVerifyResultUrl = `${accountUrl}verify-email/:uid/:token/`;
export const pendingReviewListUrl = `${accountUrl}pending-reviews/`;
export const writeReviewUrl = `${accountUrl}write-reviews/:productId/`;
export const referInviteUrl = `${accountUrl}invite/:code/`;
export const signupWithCodeUrl = `${accountUrl}s/i/:code/`;
export const dailyMarketingUrl = `${marketingUrl}daily/`;
export const brandStoryUrl = `${marketingUrl}brand-story/`;
export const welcomeUrl = `${accountUrl}welcome/`;
export const wishListUrl = `${accountUrl}wish-list/`;
export const trackingUrl = `${baseUrl}tracking`;
export const communityShareUrl = `${baseUrl}community/${slugUrl}`;
export const maccaronExperienceShareUrl = `${baseUrl}community/maccaron-experience/${slugUrl}`;
export const mstiTestUrl = `${baseUrl}msti/`;
export const mstiResultUrlWithSlug = `${baseUrl}msti/result`;
export const rankingUrl = `${productsUrl}ranking/`;
export const brandUrl = `${productsUrl}brand/${slugUrl}`;
export const brandListUrl = `${baseUrl}brand-list/`;
export const mobileShopTabUrl = `${baseUrl}tab/shop/`;
export const mobileMainMgsTabUrl = `${baseUrl}tab/mgs/`;
export const searchUrl = `${baseUrl}search/`;
export const mobileOTPVerificationUrl = `${baseUrl}otp/`;

export const tncUrl = `${baseUrl}page/tnc/`;
